// Ajce Hostel App React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";

export default function formatStudentData(students, sidenavColor) {
  const studentData = [];
  students.forEach((student) => {
    const row = {
      admno: student.admissionNo,
      student: <Student image={student.imgLink} name={student.name} email={student.email} />,
      inout: (
        <MDBox ml={-1}>
          <MDBadge
            badgeContent={student.isIn ? "In" : "Out"}
            color={student.isIn ? "success" : "error"}
            variant="gradient"
            size="sm"
          />
        </MDBox>
      ),
      admissionNo: (
        <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
          {student.admissionNo}
        </MDTypography>
      ),
      room: (
        <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
          {student.roomNo}
        </MDTypography>
      ),
      sem: (
        <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
          {student.sem}
        </MDTypography>
      ),

      viewProfile: (
        <Link to={`/students/profile/${student.admissionNo}`}>
          <MDButton variant="gradient" color={sidenavColor}>
            View
          </MDButton>
        </Link>
      ),
    };
    studentData.push(row);
  });

  function Student({ image, name }) {
    return (
      <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDAvatar src={image} name={name} size="sm" />
        <MDBox ml={2} lineHeight={1}>
          <MDTypography display="block" variant="button" fontWeight="medium">
            {name}
          </MDTypography>
        </MDBox>
      </MDBox>
    );
  }

  return {
    columns: [
      { Header: "student", accessor: "student", width: "45%", align: "left" },
      { Header: "in/out", accessor: "inout", align: "center" },
      { Header: "admission no.", accessor: "admissionNo", align: "left" },
      { Header: "room", accessor: "room", align: "center" },
      { Header: "sem", accessor: "sem", align: "center" },
      { Header: "view profile", accessor: "viewProfile", align: "center" },
    ],

    rows: studentData,
  };
}
